<div [formGroup]="form">
  <div class="form-spacing">
    <!-- Data dichiarazione (View only) -->
    <div class="column">
      <label class="label">{{ 'pre-employment.selfservice.declaration-date.label' | translate }}</label>
      <p class="text-dark">{{ form.get('createdAt')?.value | date: 'dd/MM/yyyy' }}</p>
    </div>

    <!-- Note / Dichiarazione -->
    <div class="column">
      <p class="text-dark italic">
        <span
          class="mr-2"
          [innerHTML]="'selfservice-request.previous-work-activities.notes.acknowledge.label' | translate"
        ></span>
        <span class="cursor-pointer italic" [pTooltip]="notesTooltipContent" tooltipPosition="right">
          <i class="pi pi-question-circle"></i>
        </span>
        <ng-template #notesTooltipContent>
          <span [innerHTML]="'selfservice-request.previous-work-activities.notes.acknowledge.help' | translate"></span>
        </ng-template>
      </p>
    </div>

    <!-- NOSUB: di non aver avuto rapporti di lavoro subordinato -->
    <div class="column">
      <label for="noSubordinateEmployment" class="label">
        {{ 'selfservice-request.previous-work-activities.no-subordinate-employment.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <p-select
        id="noSubordinateEmployment"
        appendTo="body"
        formControlName="noSubordinateEmployment"
        optionValue="value"
        optionLabel="label"
        [options]="timeRangeOptions"
        placeholder="{{ 'selfservice-request.previous-work-activities.time-range.placeholder' | translate }}"
        class="full-width"
      ></p-select>
      <small
        class="text-red-500 p-error"
        *ngIf="
          form.get('noSubordinateEmployment')?.invalid &&
          (form.get('noSubordinateEmployment')?.dirty || form.get('noSubordinateEmployment')?.touched)
        "
      >
        {{ 'selfservice-request.previous-work-activities.validation.required' | translate }}
      </small>
    </div>

    <!-- NOSUBINF6: rapporti di lavoro subordinato solo di durata inferiore a 6 mesi -->
    <div class="column">
      <label for="noSubordinateEmploymentUnder6Months" class="label">
        {{ 'selfservice-request.previous-work-activities.no-subordinate-employment-under-6-months.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <p-select
        id="noSubordinateEmploymentUnder6Months"
        appendTo="body"
        formControlName="noSubordinateEmploymentUnder6Months"
        optionValue="value"
        optionLabel="label"
        [options]="timeRangeOptions"
        placeholder="{{ 'selfservice-request.previous-work-activities.time-range.placeholder' | translate }}"
        class="full-width"
      ></p-select>
      <small
        class="text-red-500 p-error"
        *ngIf="
          form.get('noSubordinateEmploymentUnder6Months')?.invalid &&
          (form.get('noSubordinateEmploymentUnder6Months')?.dirty ||
            form.get('noSubordinateEmploymentUnder6Months')?.touched)
        "
      >
        {{ 'selfservice-request.previous-work-activities.validation.required' | translate }}
      </small>
    </div>

    <!-- AUTONOMO: attività autonoma con reddito annuo non superiore a 4.800 euro -->
    <div class="column">
      <label for="selfEmployment" class="label">
        {{ 'selfservice-request.previous-work-activities.self-employment.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <p-select
        id="selfEmployment"
        appendTo="body"
        formControlName="selfEmployment"
        optionValue="value"
        optionLabel="label"
        [options]="timeRangeOptions"
        placeholder="{{ 'selfservice-request.previous-work-activities.time-range.placeholder' | translate }}"
        class="full-width"
      ></p-select>
      <small
        class="text-red-500 p-error"
        *ngIf="
          form.get('selfEmployment')?.invalid &&
          (form.get('selfEmployment')?.dirty || form.get('selfEmployment')?.touched)
        "
      >
        {{ 'selfservice-request.previous-work-activities.validation.required' | translate }}
      </small>
    </div>

    <!-- COCOCO: collaborazione coordinata e continuativa con reddito annuo non superiore a 8.000 euro -->
    <div class="column">
      <label for="coordinatedCollaborationContract" class="label">
        {{ 'selfservice-request.previous-work-activities.coordinated-collaboration-contract.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <p-select
        id="coordinatedCollaborationContract"
        appendTo="body"
        formControlName="coordinatedCollaborationContract"
        optionValue="value"
        optionLabel="label"
        [options]="timeRangeOptions"
        placeholder="{{ 'selfservice-request.previous-work-activities.time-range.placeholder' | translate }}"
        class="full-width"
      ></p-select>
      <small
        class="text-red-500 p-error"
        *ngIf="
          form.get('coordinatedCollaborationContract')?.invalid &&
          (form.get('coordinatedCollaborationContract')?.dirty || form.get('coordinatedCollaborationContract')?.touched)
        "
      >
        {{ 'selfservice-request.previous-work-activities.validation.required' | translate }}
      </small>
    </div>

    <!-- DIPLOMA: possesso diploma di scuola media superiore o professionale -->
    <div class="column">
      <label for="hasCompletedSecondarySchool" class="label">
        {{ 'selfservice-request.previous-work-activities.has-completed-secondary-school.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <p-select
        id="hasCompletedSecondarySchool"
        appendTo="body"
        formControlName="hasCompletedSecondarySchool"
        optionValue="value"
        optionLabel="label"
        [options]="yesNoOptions"
        placeholder="{{ 'selfservice-request.previous-work-activities.yes-no.placeholder' | translate }}"
        class="full-width"
      ></p-select>
      @if (form.get('hasCompletedSecondarySchool')?.invalid && form.get('hasCompletedSecondarySchool')?.touched) {
        <small class="text-red-500 p-error">
          {{ 'selfservice-request.previous-work-activities.validation.required' | translate }}
        </small>
      }
    </div>
  </div>
</div>
